module.exports = __webpack_public_path__ + "img/ic-search-gray.8cf71e65.svg";